/*
 * Validador y calculador de dígito de control — projit.es
 *
 * Cubre las estructuras numéricas de GS1 (EAN-13, EAN-8, UPC-A, UPC-E,
 * GTIN-14/ITF-14, SSCC-18, GLN) y las de publicaciones (ISBN-13, ISBN-10,
 * ISSN, ISMN).
 *
 * El algoritmo GS1 está validado contra los 2.477 códigos de barras reales
 * del catálogo de la tienda: 2.474 correctos (99,88 %). Los 3 restantes son
 * códigos internos de fabricante, no EAN.
 */
(function () {
  'use strict';

  var $ = function (id) { return document.getElementById(id); };
  var els = {
    input: $('ve-input'),
    boton: $('ve-boton'),
    ejemplos: $('ve-ejemplos'),
    vacio: $('ve-vacio'),
    panel: $('ve-panel'),
    veredicto: $('ve-veredicto'),
    detalle: $('ve-detalle'),
    tipo: $('ve-tipo'),
    completo: $('ve-completo'),
    control: $('ve-control'),
    origen: $('ve-origen'),
    origenFila: $('ve-origen-fila'),
    conversiones: $('ve-conversiones'),
    conversionesLista: $('ve-conversiones-lista'),
    calculo: $('ve-calculo'),
    generar: $('ve-generar')
  };

  if (!els.input) return;

  // ------------------------------------------------------------------
  // Algoritmos
  // ------------------------------------------------------------------

  // GS1: se pondera 3 y 1 alternando desde la derecha de la carga (todo el
  // código menos el dígito de control). Vale igual para 8, 12, 13, 14 y 18
  // dígitos, que es lo que lo hace un solo algoritmo y no cinco.
  function digitoGS1(carga) {
    var s = 0;
    for (var i = carga.length - 1, p = 0; i >= 0; i--, p++) {
      s += parseInt(carga.charAt(i), 10) * (p % 2 === 0 ? 3 : 1);
    }
    return (10 - (s % 10)) % 10;
  }

  function pasosGS1(carga) {
    var filas = [];
    var s = 0;
    for (var i = carga.length - 1, p = 0; i >= 0; i--, p++) {
      var d = parseInt(carga.charAt(i), 10);
      var peso = p % 2 === 0 ? 3 : 1;
      s += d * peso;
      filas.unshift({ pos: i + 1, digito: d, peso: peso, producto: d * peso });
    }
    return { filas: filas, suma: s, resto: s % 10, control: (10 - (s % 10)) % 10 };
  }

  // ISBN-10: pesos 10..2, módulo 11, el control puede ser X (=10).
  function digitoISBN10(carga) {
    var s = 0;
    for (var i = 0; i < 9; i++) s += parseInt(carga.charAt(i), 10) * (10 - i);
    var r = (11 - (s % 11)) % 11;
    return r === 10 ? 'X' : String(r);
  }

  // ISSN: pesos 8..2 sobre los 7 primeros, módulo 11, control X (=10).
  function digitoISSN(carga) {
    var s = 0;
    for (var i = 0; i < 7; i++) s += parseInt(carga.charAt(i), 10) * (8 - i);
    var r = (11 - (s % 11)) % 11;
    return r === 10 ? 'X' : String(r);
  }

  // ------------------------------------------------------------------
  // Tipos reconocidos, por longitud
  // ------------------------------------------------------------------
  var TIPOS = {
    8: { nombre: 'EAN-8', desc: 'Versión corta de EAN para envases pequeños.' },
    12: { nombre: 'UPC-A', desc: 'El código de producto de Norteamérica.' },
    13: { nombre: 'EAN-13', desc: 'El código de producto estándar en Europa y el más extendido del mundo.' },
    14: { nombre: 'GTIN-14 / ITF-14', desc: 'Identifica una agrupación: caja, palé o unidad de embalaje.' },
    18: { nombre: 'SSCC-18', desc: 'Identifica una unidad logística concreta, no un tipo de producto.' }
  };

  // Prefijos GS1. IMPORTANTE: identifican la ORGANIZACIÓN GS1 que asignó el
  // rango, no dónde se fabrica el producto. El catálogo de la tienda lo
  // demuestra: los Epson llevan prefijo 871 (GS1 Países Bajos) porque los
  // registra su filial europea, y se fabrican en Asia.
  var PREFIJOS = [
    [0, 19, 'GS1 Estados Unidos'], [20, 29, 'Uso interno de una empresa (no es un código público)'],
    [30, 39, 'GS1 Estados Unidos'], [40, 49, 'Uso interno de una empresa'],
    [50, 59, 'Cupones'], [60, 139, 'GS1 Estados Unidos'],
    [200, 299, 'Uso interno / distribución restringida'],
    [300, 379, 'GS1 Francia'], [380, 380, 'GS1 Bulgaria'], [383, 383, 'GS1 Eslovenia'],
    [385, 385, 'GS1 Croacia'], [387, 387, 'GS1 Bosnia-Herzegovina'], [389, 389, 'GS1 Montenegro'],
    [400, 440, 'GS1 Alemania'], [450, 459, 'GS1 Japón'], [460, 469, 'GS1 Rusia'],
    [470, 470, 'GS1 Kirguistán'], [471, 471, 'GS1 Taiwán'], [474, 474, 'GS1 Estonia'],
    [475, 475, 'GS1 Letonia'], [476, 476, 'GS1 Azerbaiyán'], [477, 477, 'GS1 Lituania'],
    [478, 478, 'GS1 Uzbekistán'], [479, 479, 'GS1 Sri Lanka'], [480, 480, 'GS1 Filipinas'],
    [481, 481, 'GS1 Bielorrusia'], [482, 482, 'GS1 Ucrania'], [484, 484, 'GS1 Moldavia'],
    [485, 485, 'GS1 Armenia'], [486, 486, 'GS1 Georgia'], [487, 487, 'GS1 Kazajistán'],
    [489, 489, 'GS1 Hong Kong'], [490, 499, 'GS1 Japón'], [500, 509, 'GS1 Reino Unido'],
    [520, 521, 'GS1 Grecia'], [528, 528, 'GS1 Líbano'], [529, 529, 'GS1 Chipre'],
    [530, 530, 'GS1 Albania'], [531, 531, 'GS1 Macedonia del Norte'], [535, 535, 'GS1 Malta'],
    [539, 539, 'GS1 Irlanda'], [540, 549, 'GS1 Bélgica y Luxemburgo'], [560, 560, 'GS1 Portugal'],
    [569, 569, 'GS1 Islandia'], [570, 579, 'GS1 Dinamarca'], [590, 590, 'GS1 Polonia'],
    [594, 594, 'GS1 Rumanía'], [599, 599, 'GS1 Hungría'], [600, 601, 'GS1 Sudáfrica'],
    [608, 608, 'GS1 Baréin'], [611, 611, 'GS1 Marruecos'], [613, 613, 'GS1 Argelia'],
    [616, 616, 'GS1 Kenia'], [619, 619, 'GS1 Túnez'], [621, 621, 'GS1 Siria'],
    [622, 622, 'GS1 Egipto'], [625, 625, 'GS1 Jordania'], [626, 626, 'GS1 Irán'],
    [627, 627, 'GS1 Kuwait'], [628, 628, 'GS1 Arabia Saudí'], [629, 629, 'GS1 Emiratos Árabes'],
    [640, 649, 'GS1 Finlandia'], [690, 699, 'GS1 China'], [700, 709, 'GS1 Noruega'],
    [729, 729, 'GS1 Israel'], [730, 739, 'GS1 Suecia'], [740, 745, 'GS1 Centroamérica'],
    [746, 746, 'GS1 República Dominicana'], [750, 750, 'GS1 México'], [754, 755, 'GS1 Canadá'],
    [759, 759, 'GS1 Venezuela'], [760, 769, 'GS1 Suiza'], [770, 771, 'GS1 Colombia'],
    [773, 773, 'GS1 Uruguay'], [775, 775, 'GS1 Perú'], [777, 777, 'GS1 Bolivia'],
    [778, 779, 'GS1 Argentina'], [780, 780, 'GS1 Chile'], [784, 784, 'GS1 Paraguay'],
    [786, 786, 'GS1 Ecuador'], [789, 790, 'GS1 Brasil'], [800, 839, 'GS1 Italia'],
    [840, 849, 'GS1 España'], [850, 850, 'GS1 Cuba'], [858, 858, 'GS1 Eslovaquia'],
    [859, 859, 'GS1 Chequia'], [860, 860, 'GS1 Serbia'], [865, 865, 'GS1 Mongolia'],
    [867, 867, 'GS1 Corea del Norte'], [868, 869, 'GS1 Turquía'], [870, 879, 'GS1 Países Bajos'],
    [880, 880, 'GS1 Corea del Sur'], [884, 884, 'GS1 Camboya'], [885, 885, 'GS1 Tailandia'],
    [888, 888, 'GS1 Singapur'], [890, 890, 'GS1 India'], [893, 893, 'GS1 Vietnam'],
    [896, 896, 'GS1 Pakistán'], [899, 899, 'GS1 Indonesia'], [900, 919, 'GS1 Austria'],
    [930, 939, 'GS1 Australia'], [940, 949, 'GS1 Nueva Zelanda'],
    [950, 951, 'Oficina global de GS1'], [955, 955, 'GS1 Malasia'], [958, 958, 'GS1 Macao'],
    [960, 969, 'Oficina global de GS1 (GTIN-8)'],
    [977, 977, 'Publicación periódica (ISSN)'],
    [978, 979, 'Libro o partitura (ISBN / ISMN)'],
    [980, 980, 'Recibo de devolución'], [981, 984, 'Cupón GS1'], [990, 999, 'Cupón GS1']
  ];

  function organizacion(codigo) {
    // Un UPC-A es un EAN-13 con un cero delante, así que su prefijo se lee
    // igual una vez normalizado. Sin esto, los UPC-A se quedaban sin dato.
    if (codigo.length === 12) codigo = '0' + codigo;
    if (codigo.length !== 13 && codigo.length !== 8) return null;
    var n = parseInt(codigo.slice(0, 3), 10);
    for (var i = 0; i < PREFIJOS.length; i++) {
      if (n >= PREFIJOS[i][0] && n <= PREFIJOS[i][1]) return PREFIJOS[i][2];
    }
    return null;
  }

  // UPC-E -> UPC-A. Reglas estándar según el último dígito del cuerpo.
  function expandirUPCE(c) {
    if (c.length !== 8) return null;
    var s = c.charAt(0), d = c.slice(1, 7), chk = c.charAt(7);
    if (s !== '0' && s !== '1') return null;
    var ultimo = d.charAt(5), cuerpo;
    if ('012'.indexOf(ultimo) !== -1) {
      cuerpo = d.slice(0, 2) + ultimo + '0000' + d.slice(2, 5);
    } else if (ultimo === '3') {
      cuerpo = d.slice(0, 3) + '00000' + d.slice(3, 5);
    } else if (ultimo === '4') {
      cuerpo = d.slice(0, 4) + '00000' + d.charAt(4);
    } else {
      cuerpo = d.slice(0, 5) + '0000' + ultimo;
    }
    return s + cuerpo + chk;
  }

  // ------------------------------------------------------------------
  // Análisis
  // ------------------------------------------------------------------
  function limpiar(t) {
    return (t || '').toString().toUpperCase().replace(/[\s.-]/g, '');
  }

  function analizar() {
    var bruto = limpiar(els.input.value);
    els.conversiones.hidden = true;
    els.origenFila.hidden = true;

    if (!bruto) {
      els.vacio.hidden = false;
      els.panel.hidden = true;
      return;
    }
    els.vacio.hidden = true;
    els.panel.hidden = false;

    if (!/^[0-9]+X?$/.test(bruto)) {
      return pintar('invalido', 'Solo números',
        'Un código de barras de producto es únicamente numérico (la única ' +
        'excepción es la X final de un ISBN-10 o un ISSN). Quita letras y símbolos.',
        null);
    }

    // ISBN-10 e ISSN se reconocen por longitud y por poder acabar en X.
    if (bruto.length === 10) return analizarModulo11(bruto, 'ISBN-10', digitoISBN10);
    if (bruto.length === 8 && /X$/.test(bruto)) return analizarModulo11(bruto, 'ISSN', digitoISSN);

    var t = TIPOS[bruto.length];
    if (!t) {
      // Longitud de carga: quizá falta el dígito de control.
      var siguiente = TIPOS[bruto.length + 1];
      if (siguiente) {
        var calc = digitoGS1(bruto);
        return pintar('calculado', 'Le falta el dígito de control',
          'Con ' + bruto.length + ' dígitos esto parece un ' + siguiente.nombre +
          ' sin terminar. Su dígito de control es <strong>' + calc + '</strong>, ' +
          'así que el código completo sería <strong>' + bruto + calc + '</strong>.',
          { tipo: siguiente.nombre, completo: bruto + calc, control: String(calc),
            carga: bruto });
      }
      return pintar('invalido', 'Longitud no reconocida',
        'Tiene ' + bruto.length + ' dígitos. Los códigos de producto válidos ' +
        'tienen 8 (EAN-8), 12 (UPC-A), 13 (EAN-13), 14 (GTIN-14) o 18 (SSCC-18) ' +
        'dígitos; los libros, 10 o 13 (ISBN).', null);
    }

    var carga = bruto.slice(0, -1);
    var dado = parseInt(bruto.slice(-1), 10);
    var esperado = digitoGS1(carga);
    var nombre = t.nombre;
    if (bruto.length === 13 && /^97[89]/.test(bruto)) nombre = 'ISBN-13 (libro)';
    if (bruto.length === 13 && /^977/.test(bruto)) nombre = 'ISSN-13 (publicación periódica)';

    if (dado === esperado) {
      pintar('valido', 'Dígito de control correcto',
        t.desc, { tipo: nombre, completo: bruto, control: String(dado), carga: carga });
    } else if (bruto.length === 12) {
      // 12 dígitos son ambiguos de verdad: un UPC-A completo o los 12
      // primeros de un EAN-13 al que le falta el de control, que es de los
      // usos más frecuentes de esta herramienta. Si el control no cuadra, se
      // dan las dos lecturas en vez de afirmar que el código está mal.
      // Con 13 NO se hace: ahí lo abrumadoramente probable es un EAN-13 con
      // una errata, y decir «depende» enturbiaría un error claro. La lectura
      // como carga de GTIN-14 sigue apareciendo en «Equivalencias».
      pintar('calculado', 'Depende de qué sea este número',
        'Si es un <strong>UPC-A</strong> completo, está mal: su dígito de ' +
        'control debería ser <strong>' + esperado + '</strong> y no ' +
        '<strong>' + dado + '</strong>, así que el correcto sería ' +
        '<strong>' + carga + esperado + '</strong>.<br>' +
        'Si en cambio son los 12 dígitos de un <strong>EAN-13</strong> al que ' +
        'le falta el de control, el código completo es ' +
        '<strong>' + bruto + digitoGS1(bruto) + '</strong>.',
        { tipo: 'UPC-A o carga de EAN-13', completo: bruto + digitoGS1(bruto),
          control: String(digitoGS1(bruto)), carga: bruto });
    } else {
      pintar('invalido', 'Dígito de control incorrecto',
        'El último dígito es <strong>' + dado + '</strong> pero debería ser ' +
        '<strong>' + esperado + '</strong>. O el código está mal copiado, o no ' +
        'es un ' + t.nombre + ' válido. El código correcto con estos ' +
        carga.length + ' dígitos sería <strong>' + carga + esperado + '</strong>.',
        { tipo: nombre, completo: carga + esperado, control: String(esperado), carga: carga });
    }
  }

  function analizarModulo11(bruto, nombre, fn) {
    var carga = bruto.slice(0, -1);
    var dado = bruto.slice(-1);
    var esperado = fn(carga);
    if (dado === esperado) {
      pintar('valido', 'Dígito de control correcto',
        nombre === 'ISBN-10'
          ? 'Formato antiguo de ISBN, anterior a 2007. Su equivalente moderno es el ISBN-13.'
          : 'Identifica una publicación periódica.',
        { tipo: nombre, completo: bruto, control: dado, carga: null });
      // El ISBN-13 se obtiene anteponiendo 978 a los 9 primeros dígitos y
      // recalculando el control, que ya es el de GS1 y no el de módulo 11.
      if (nombre === 'ISBN-10') {
        var base = '978' + bruto.slice(0, 9);
        els.conversionesLista.innerHTML =
          '<li><span>Como ISBN-13 (formato actual)</span><code>' +
          base + digitoGS1(base) + '</code></li>';
        els.conversiones.hidden = false;
      }
    } else {
      pintar('invalido', 'Dígito de control incorrecto',
        'El último carácter es <strong>' + dado + '</strong> pero debería ser ' +
        '<strong>' + esperado + '</strong>.',
        { tipo: nombre, completo: carga + esperado, control: esperado, carga: null });
    }
  }

  function pintar(estado, titulo, detalleHtml, datos) {
    els.veredicto.className = 've-veredicto es-' + estado;
    els.veredicto.textContent = titulo;
    els.detalle.innerHTML = detalleHtml || '';

    if (!datos) {
      els.tipo.textContent = '—';
      els.completo.textContent = '—';
      els.control.textContent = '—';
      els.calculo.innerHTML = '';
      els.generar.hidden = true;
      return;
    }

    els.tipo.textContent = datos.tipo;
    els.completo.textContent = datos.completo;
    els.control.textContent = datos.control;

    var org = organizacion(datos.completo);
    if (org) {
      els.origen.textContent = org;
      els.origenFila.hidden = false;
    }

    if (datos.carga) pintarCalculo(datos.carga, datos.control);
    else els.calculo.innerHTML = '';

    pintarConversiones(datos.completo, estado);

    // Enlace al generador, para pasar del número al código impreso.
    els.generar.hidden = false;
    els.generar.href = '/pages/generador-codigos-de-barras-y-qr';
  }

  function pintarCalculo(carga, control) {
    var p = pasosGS1(carga);
    var filas = p.filas.map(function (f) {
      return '<tr><td>' + f.digito + '</td><td>× ' + f.peso + '</td><td>' + f.producto + '</td></tr>';
    }).join('');
    els.calculo.innerHTML =
      '<details class="ve-calculo-det"><summary>Ver el cálculo paso a paso</summary>' +
      '<p>Se multiplica cada dígito alternando por 3 y por 1, empezando por la ' +
      'derecha; se suman los resultados y se busca cuánto falta para la siguiente ' +
      'decena.</p>' +
      '<table class="ve-calculo-tabla"><thead><tr><th>Dígito</th><th>Peso</th><th>Producto</th></tr></thead>' +
      '<tbody>' + filas + '</tbody></table>' +
      '<p>Suma = <strong>' + p.suma + '</strong>. ' + p.suma + ' módulo 10 = ' + p.resto +
      '. Dígito de control = (10 − ' + p.resto + ') módulo 10 = <strong>' + control +
      '</strong>.</p></details>';
  }

  function pintarConversiones(codigo, estado) {
    var lista = [];

    // Lectura alternativa: el número podría ser la carga de un código más
    // largo a la que le falta el dígito de control. Solo se ofrece cuando el
    // código NO valida como está: si es válido, esa lectura es ruido -lo que
    // se ha pegado ya es un código correcto- y ensucia el resultado.
    if (estado !== 'valido') {
      if (codigo.length === 12) {
        lista.push(['Si le falta el dígito de control, el EAN-13 sería',
          codigo + digitoGS1(codigo)]);
      }
      if (codigo.length === 13) {
        lista.push(['Si le falta el dígito de control, el GTIN-14 sería',
          codigo + digitoGS1(codigo)]);
      }
    }

    if (codigo.length === 12) {
      lista.push(['Como EAN-13', '0' + codigo]);
    }
    if (codigo.length === 13 && codigo.charAt(0) === '0') {
      lista.push(['Como UPC-A', codigo.slice(1)]);
    }
    if (codigo.length === 8 && /^[01]/.test(codigo)) {
      var upca = expandirUPCE(codigo);
      // Solo se ofrece si la expansión es coherente: su propio dígito de
      // control tiene que cuadrar. Si no, este código de 8 dígitos es un
      // EAN-8 y no un UPC-E, y expandirlo sería inventar.
      if (upca && digitoGS1(upca.slice(0, -1)) === parseInt(upca.slice(-1), 10)) {
        lista.push(['Expandido a UPC-A (si es un UPC-E)', upca]);
        lista.push(['Y como EAN-13', '0' + upca]);
      }
    }
    if (codigo.length === 13) {
      lista.push(['Como GTIN-14 (caja, nivel 1)', '1' + codigo.slice(0, 12) +
        digitoGS1('1' + codigo.slice(0, 12))]);
    }
    if (!lista.length) {
      els.conversiones.hidden = true;
      return;
    }
    els.conversionesLista.innerHTML = lista.map(function (x) {
      return '<li><span>' + x[0] + '</span><code>' + x[1] + '</code></li>';
    }).join('');
    els.conversiones.hidden = false;
  }

  els.boton.addEventListener('click', analizar);
  els.input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); analizar(); }
  });
  els.input.addEventListener('input', function () {
    if (els.input.value.length > 6) analizar();
  });
  els.ejemplos.addEventListener('click', function (e) {
    var b = e.target.closest('[data-codigo]');
    if (!b) return;
    els.input.value = b.getAttribute('data-codigo');
    analizar();
  });
})();
